import { createStore } from 'stimulus-store';

export const roomStore = createStore({
    name: 'roomStore',
    type: Object,
    initialValue: {}
});